export default __webpack_public_path__ + "static/media/private_session_icon.6ff9f469.svg";